import { Session } from '@ais-ui/auth';

export const deleteBookmark = async (
  session: Session,
  id: string
): Promise<string> => {
  const response = await session.request('deleteBookmark', {
    uuid: id,
  });

  return response;
};
